import { render } from "./SingleDay.vue?vue&type=template&id=bcdab0bc&scoped=true"
import script from "./SingleDay.vue?vue&type=script&lang=js"
export * from "./SingleDay.vue?vue&type=script&lang=js"

import "./SingleDay.vue?vue&type=style&index=0&id=bcdab0bc&scoped=true&lang=css"
import "./SingleDay.vue?vue&type=style&index=1&id=bcdab0bc&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcdab0bc"]])

export default __exports__